import React from 'react';
import { View, Text, Image, TouchableOpacity } from 'react-native-web';
import { VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import Colors from "../../../constants/Colors";
import {TimelineIcon} from "./TimelineResolveIcon";
import {Spacing} from "../../../components";

const TimelineComponent = (props) => {

    const { title, shortDescription, isCompleted, type } = props.content;

    return (
        <VerticalTimelineElement
            contentStyle={{ background: Colors.cardBackgroundColor, color: Colors.cardBackgroundColor }}
            iconStyle={{ background: Colors.cardBackgroundColor, color: Colors.cardBackgroundColor, justifyContent: 'center', alignItems: 'center' }}
            icon={<TimelineIcon contentType={type} />}
            onTimelineElementClick={() => props.onClick(props.content)}
        >

            <View
                style={{ flexDirection: 'row', maxWidth: '90%', alignItems: 'center' }}
            >
                <Text style={{ marginLeft: 12, color: 'white', fontSize: 22, fontWeight: 'bold' }}>
                    { title }
                </Text>
                {
                    isCompleted === true &&
                        <Image
                            source={require('./icons/checkIcon.png')}
                            style={{ width: 32, height: 32, marginLeft: 12 }}
                            resizeMode={'contain'}
                        />
                }
            </View>

            <Spacing height={12} />
            <Text style={{ marginLeft: 12, color: 'white', fontSize: 14 }}>
                { shortDescription }
            </Text>

        </VerticalTimelineElement>
    )

}

export default TimelineComponent;
